/**
 * The landing pages' way to a new account, beside "Sign in" (03 §1.4): "Create account" while `signupMode` is `open`,
 * "I have an invite" while it is `invite` (and offline), nothing while it is `closed`.
 */
import { t } from '@tarock/i18n';
import type { SignupMode } from '@tarock/protocol';
import { useEffect, useState } from 'preact/hooks';
import { publicConfig } from '../auth/config';

/** A link to `/signup` that matches the sign-up mode; nothing until the config is in. */
export function SignupLink() {
  const [mode, setMode] = useState<SignupMode | null>(null);
  useEffect(() => {
    void publicConfig().then((c) => setMode(c?.signupMode ?? 'invite'));
  }, []);
  if (mode === 'open') {
    return (
      <a class="btn" href="/signup" data-testid="create-account">
        {t('landing.createAccount')}
      </a>
    );
  }
  if (mode === 'invite') {
    return (
      <a href="/signup" data-testid="have-invite">
        {t('landing.haveInvite')}
      </a>
    );
  }
  return null;
}
